import React from 'react';
import { Button, Checkbox, Form, Input } from 'antd';
import { NavLink, useNavigate } from 'react-router-dom';
import { AuthWrapper } from './style';
import { AuthApi } from 'api';
import styled from 'styled-components';

//@ts-ignore
import FeatherIcon from 'feather-icons-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { decodeJWT, getRole } from 'utility/decode-jwt';
import { PredefinedRoles } from 'constants/constants';
import isOrganizationUser from 'utility/isOrganizationUser';
import isSuperAdminUser from 'utility/isSuperAdminUser';

const authApi = new AuthApi();

const CenteredContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
`;

const LogoContainer = styled.div`
  text-align: center;
  margin-bottom: 24px;
`;

const Logo = styled.img`
  max-width: 200px;
  height: auto;
`;

const SubmitButton = styled(Button)`
  width: 100%;
  margin-top: 16px;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 24px;
`;

function SignIn() {
  const { t, i18n } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const navigate = useNavigate();
  const [form] = Form.useForm();
  useEffect(() => {
    const isLoggedIn = localStorage.getItem('user');
    if (isLoggedIn) {
      navigate('/', { replace: true });
    }
  }, [navigate]);
  const handleFormSubmit = async () => {
    try {
      setIsLoading(true);

      const payload = form.getFieldsValue();

      const { data } = await authApi.apiAuthLoginPost({
        loginCommand: { ...payload, rememberMe },
      });

      localStorage.setItem('user', JSON.stringify(data));

      const token: any = decodeJWT();
      if (token) {
        const languagecode = token?.language;
        i18n.changeLanguage(languagecode);
      }

      let navigateTo = '/';
      if (isSuperAdminUser()) navigateTo = '/organizations';
      if (isOrganizationUser()) navigateTo = '/dashboard';
      if (data.shouldShowOnboarding) navigateTo = '/set-new-password';
      navigate(navigateTo, { replace: true });
    } catch (error) {
      // Handle error
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <AuthWrapper>
      <CenteredContainer>
        <div className="auth-contents">
          <Form name="signIn" form={form} onFinish={handleFormSubmit} layout="vertical">
            <LogoContainer>
              <Logo src={require('../../static/img/org-logo/adriatic-project-logo.png')} alt="Logo" />
            </LogoContainer>

            <Form.Item
              name="email"
              rules={[
                {
                  message: t('signIn.emailRequired', {
                    defaultValue: 'Please input your Email!',
                  }),
                  required: true,
                },
              ]}
            >
              <Input
                placeholder={t('signIn.emailPlaceholder', {
                  defaultValue: 'Email',
                })}
                prefix={<FeatherIcon icon="mail" size={16} />}
              />
            </Form.Item>
            <Form.Item name="password">
              <Input.Password
                placeholder={t('signIn.passwordPlaceholder', {
                  defaultValue: 'Password',
                })}
                prefix={<FeatherIcon icon="lock" size={16} />}
              />
            </Form.Item>
            <div className="auth-form-action">
              <Checkbox onChange={() => setRememberMe(!rememberMe)}>
                {t('signIn.remember-me', { defaultValue: 'Remember me' })}
              </Checkbox>
              <NavLink className="forgot-pass-link" to="/forgot-password">
                {t('signIn.forgotPassword', {
                  defaultValue: 'Forgot password?',
                })}
              </NavLink>
            </div>
            <ButtonContainer>
              <SubmitButton htmlType="submit" type="primary" size="large" disabled={isLoading}>
                {isLoading
                  ? t('signIn.loading', { defaultValue: 'Loading...' })
                  : t('signIn.signIn', { defaultValue: 'Sign In' })}
              </SubmitButton>
            </ButtonContainer>
          </Form>
        </div>
      </CenteredContainer>
    </AuthWrapper>
  );
}

export default SignIn;
